import { App } from 'antd';
import { useEffect } from 'react';
import { registerConfirmModal } from '../lib/confirmAction';

/** Registers App.useApp().modal for confirmAction() so static Modal.confirm is not used. */
export function ConfirmModalBridge() {
  const { modal } = App.useApp();

  useEffect(() => {
    registerConfirmModal(modal);
    return () => registerConfirmModal(null);
  }, [modal]);

  return null;
}
